import React from 'react'
import { useParams } from 'react-router-dom'
import OptionSelectionContent from './OptionSelectionContent'
import styles from './OptionSelection.module.sass'

const OptionSelection = () => {
  const { package_id: packageId } = useParams()

  return (
    <div className={styles.container}>
      <OptionSelectionContent packageId={packageId} />
    </div>
  )
}

export default OptionSelection
